import { ApiConfig, HttpService, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { MS_PER_MINUTE } from '@skylab-shared/utils';
import { ReportPrintQuery, ReportPrintQueryParameters, ReportPrintResult } from '../queries/report-print.query-base';

export interface SaleRegistryPrintingResult extends ReportPrintResult { }

export interface SaleRegistryPrintingParameters extends ReportPrintQueryParameters { }

export class SaleRegistryPrintingQuery extends ReportPrintQuery<SaleRegistryPrintingResult> {
    public constructor(parameters: SaleRegistryPrintingParameters) {
        super(parameters);
    }
}

export class SaleRegistryPrintingQueryHandlerBase implements QueryHandler<SaleRegistryPrintingQuery, SaleRegistryPrintingResult> {
    private static Url = TaggedUrl.join('saleRegistry/printing', [Tags.Api]);

    public constructor(private readonly http: HttpService) {  }

    public async handleAsync({ parameters }: SaleRegistryPrintingQuery): Promise<SaleRegistryPrintingResult> {
        const requestData = {
            compress: parameters.compress,
            password: parameters.password,
            ecoMode: parameters.ecoMode,
            landscape: parameters.landscape,
            config: {
                parameters: JSON.stringify(parameters.parameters),
                columns: parameters.columns,
                summary: parameters.summary,
                report: 'RejestrSprzedazy'
            }
        };

        const { data } = await this.http.post<{ url: string; }>(SaleRegistryPrintingQueryHandlerBase.Url, requestData, {timeout: 3 * MS_PER_MINUTE });
        return {
            url: `${ApiConfig.baseUrl}${data.url}`
        };
    }
}
